module.exports = __webpack_public_path__ + "media/images/home/ic_view-3aebe7b47cbb6306c7aab84d05919752.svg";